//------------------imports---------------------
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import AddToolbar from "../../components/common/AddToolbar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import Slide from "@mui/material/Slide";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { SETTINGS_API_06 } from "../../api/ApiModel";
import { useSelector } from "react-redux";

const Waiters = () => {
  //---------------------------------hooks---------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const [data, setData] = useState(null);
  const styles = useStyles(theme);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    IDNO: "",
    NAME: "",
  });

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_06, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        IDNO: String(selectedItem.IDNO),
        NAME: selectedItem.NAME,
      });
    }
  }, [selectedItem]);
  // --------------------functions----------------

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
    setSelectedItemDetails({
      ...selectedItemDetails,
      [name]: value,
    });
  };

  const handleConfirmClick = async () => {
    const { NAME } = selectedItemDetails;
    const requiredFields = [{ name: "NAME", value: NAME, label: "Name" }];
    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });

      setErrors(newError);
      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      setSnackbarMessage(`Required fields: ${missingFieldLabels}.`);
      setOpenErrorSnackbar(true);
      return;
    }

    if (data) {
      const isDuplicate = data.some((item) => {
        if (item.IDNO != selectedItemDetails.IDNO && item.NAME === NAME) {
          return true;
        } else {
          return false;
        }
      });
      if (isDuplicate) {
        setSnackbarMessage("  Name already exists.");
        setOpenErrorSnackbar(true);
        return; // Stop the function if a duplicate is foundIDNO
      }
    }

    const staticValues = {
      COMPCODE,
      LOCCODE,
      RESTCODE,
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    };

    try {
      const responseData = await externalpostApi(SETTINGS_API_06, payload);
      setOpenSnackbar(true);
      setSelectedItemDetails({
        IDNO: "",
        NAME: "",
      });
    } catch (error) {
      console.error("Error:", error);
    }

    setTimeout(() => {
      navigate("/vwaiters");
    }, 2000);
  };

  const handleClearClick = () => {
    setSelectedItemDetails({
      NAME: "",
    });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false);
  };

  return (
    <div>
      <Navbar />

      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">Waiters</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={() => navigate("/vwaiters")}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{ name: isEdit ? "Edit Waiter" : "Create Waiter" }}
        />
        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              label={
                <span>
                  Name<span style={{ color: "red" }}> *</span>
                </span>
              }
              size="small"
              fullWidth
              variant="outlined"
              autoComplete="off"
              name="NAME"
              value={selectedItemDetails.NAME}
              onChange={handleInputChange}
              error={Boolean(errors.NAME)}
              helperText={errors.NAME}
            />
          </Grid>
        </Grid>

        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleConfirmClick}
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Stack>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            {isEdit
              ? "Waiter Updated Successfully!"
              : "Waiter Created Successfully!"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorSnackbar}
          autoHideDuration={3000}
          onClose={handleErrorSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: "10%", right: "10%" }}
        >
          <Alert
            onClose={handleErrorSnackbarClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
};

export default Waiters;
